<template>
    <div class="baner-vertical-long baner-top-vertical" v-if="currentCity != null && banerArr != null && banerTopCoockieVisible == true" :style="'background-color:' + banerArr[0].bg" id="banerTopHorizont">
        <!-- 1200x100 -->
        <div class="container" v-if="!iSmobile">
            <div class="banner-full-size desctop-baner">
                <a :href="banerArr[0].link" target="_blank">
                    <img :src="banerArr[0].baners_gif.baner_desctop" alt="">
                </a>
            </div>
            <a href="#" @click.prevent="closeBaner" class="close-baner-link">
                <svg-icon icon-class="close" className="svg-icon icon-close"/>
            </a>
        </div>
        
        <div class="banner-full-size mobile-baner" v-if="iSmobile">
            <a :href="banerArr[0].link" target="_blank">
                <img :src="banerArr[0].baners_gif.baner_mobile" alt="">
            </a>
            <a href="#" @click.prevent="closeBaner" class="close-baner-link-mobile">
                <svg-icon icon-class="close" className="svg-icon icon-close"/>
            </a>
        </div>
        <!-- Верхний банер -->
        <!-- {{options[0].page}} -->
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'baner-top-vaertical',
        props: ['options'],
        components: {
        },
        data () {
            return {
                banerArr: null,
                iSmobile:  false,
            }
        },
        computed: mapGetters({
            banerSystem: 'loadBanerSystem',
            currentCity: 'loadCurCity',
            banerTopCoockieVisible: 'loadCockieBanerTopVisible',
        }),
        methods: {
            suffleArr() {
                if (this.currentCity != null) {
                    var data = this.banerSystem.top_vertical_baners,
                        city = this.currentCity.slug;
                    var filteredItems = data.filter(item => {
                        return (
                            item.gorod.slug == city && 
                            item.baner_init == 'true'
                            // item.view_on_page.find(x => x == this.options[0].page) &&
                        );
                    });
                    if (filteredItems.length > 0) {
                        this.banerArr = _.shuffle(filteredItems);
                    } else {
                        this.banerArr = null;
                        this.closeBaner();
                    }
                    // console.log(filteredItems, filteredItems.length, 'BANER')
                }
            },
            // MOBILE CHECKER
            isMobileCheck() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                }
            },
            handleResize() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                } else {
                    this.iSmobile = false
                }
            },
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
            closeBaner() {
                this.$cookie.set('baner_top_shablon_visible', false, { expires: '1D' });
                this.$store.commit('coockieBanerTopVisible', false);
                // var cockie = this.$cookie.get('baner_top_visible');
                // console.log('close baner', cockie);
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
            this.suffleArr();
            this.isMobileCheck();
            this.checkResize();
            this.$store.watch(
                (state) => state.pageSetup,
                (newValue) => {
                    if (newValue != null) {
                        this.suffleArr();
                    }
                }
            );
            this.$store.watch(
                (state) => state.currentCity,
                (newValue) => {
                   this.suffleArr();
                }
            );
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/baner-system/baner-top-vertical.scss';
    // @import '@/styles/respond/404/404-page-respond.scss';
</style>